import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forYou = ['Eres un latino de fe viviendo en EE.UU. con el sueño de tener tu propio negocio.', 'Quieres dejar de trabajar para otros y construir algo propio con propósito.', 'Buscas una guía práctica que combine principios bíblicos con estrategias reales de negocio.', 'Estás dispuesto a tomar acción y ser un mayordomo fiel de tus talentos.', 'Quieres proteger legalmente a tu familia con una estructura de negocio sólida.'];
const notForYou = ['Buscas hacerte rico sin esfuerzo ni disciplina.', 'No estás dispuesto a invertir tiempo en aprender y aplicar.', 'Quieres atajos que comprometan tu integridad y tus valores.'];
export function TargetAudienceSection() {
  return <section className="bg-navy py-20 md:py-28 px-4" data-id="element-213">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 border border-gold/30 p-8 rounded-2xl" data-id="element-215">
          <h2 className="text-2xl md:text-3xl text-gold mb-8" data-id="element-216">
            Este Blueprint ES para Ti Si...
          </h2>
          <ul className="space-y-6" data-id="element-217">
            {forYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-white" data-id="element-218">
                <Check className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-219" />
                <span className="leading-relaxed" data-id="element-220">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 border border-urgency/30 p-8 rounded-2xl" data-id="element-221">
          <h2 className="text-2xl md:text-3xl text-urgency mb-8" data-id="element-222">
            Este Blueprint NO es para Ti Si...
          </h2>
          <ul className="space-y-6" data-id="element-223">
            {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3 text-white/80" data-id="element-224">
                <X className="w-6 h-6 text-urgency flex-shrink-0 mt-0.5" data-id="element-225" />
                <span className="leading-relaxed" data-id="element-226">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}